import { ApplicationConfig, provideZoneChangeDetection, isDevMode, LOCALE_ID } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { provideServiceWorker } from '@angular/service-worker';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { routes } from './app.routes';



// export const DASHBOARD_ROUTES = [
//   { path: '', component: DashboardComponent }
// ];

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(),
    TranslateModule.forRoot({
      defaultLanguage: 'en-US',
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => ({
          getTranslation: (lang: string) => http.get(`./assets/i18n/${lang}.json`)
        } as TranslateLoader),
        deps: [HttpClient]
      }
    }).providers!,
    {
      provide: LOCALE_ID,
      useValue: getStoredLanguage()
    },
    provideServiceWorker('ngsw-worker.js', {
      enabled: isDevMode() || environment.production === true,
      registrationStrategy: 'registerWhenStable:30000'
    })
  ]
};

function getStoredLanguage(): string {
  // Sprawdzenie localStorage
  if (typeof localStorage !== 'undefined') {
    const stored = localStorage.getItem('language');
    if (stored === 'pl-PL' || stored === 'en-US') {
      return stored;
    }
  }

  // Sprawdzenie preferencji przeglądarki
  const browserLang = navigator.language.toLowerCase();
  if (browserLang.startsWith('pl')) {
    return 'pl-PL';
  }

  // Domyślnie angielski
  return 'en-US';
}
